import React from "react";
import ToggleButton from "../accessories/ToggleButton";

const Settings = () => {
    return (
        <div>
            <header>
                <h2>Settings</h2>
            </header>
            <section className="change-theme-container">
                <span>Theme Settings:</span>
                <div style={{display:"inline-block"}} className="change-theme-wrapper">
                    <span>Default</span>
                    <ToggleButton />
                    <span>Light</span>
                </div>
            </section>
        </div>
    );
};

export default Settings;
